import SSP_ADVERT_CONSTANTS from 'components/sspAdverts/sspAdvertsConstants';
import { type FilterSignalData } from 'signals/filters';
import { categoriesMap } from 'signals/category';
import { CATEGORY_ID } from 'utils/category';
import { type CategoryTreeCategory } from 'components/modal/categories/signals.ts';
import { type OfferUnion } from 'utils/isOfferType';

function getSectionRootCategory(category: CategoryTreeCategory): CategoryTreeCategory {
	// special section for concat seo name with parent seo name
	if (category.id === CATEGORY_ID.METALWORKING_MACHINES) {
		return category;
	}

	if (category.parent) {
		return getSectionRootCategory(category.parent);
	}
	return category;
}

function getCategorySectionFromCurrentCategory(currentCategory: CategoryTreeCategory | undefined) {
	if (currentCategory) {
		const rootCategory = getSectionRootCategory(currentCategory);
		if (!rootCategory) {
			return `${currentCategory.seoName}`;
		}

		if (rootCategory.id === CATEGORY_ID.METALWORKING_MACHINES && rootCategory.parent) {
			return `/${rootCategory.parent.seoName}/${rootCategory.seoName}`;
		}

		return `/${rootCategory.seoName}`;
	}
	return '';
}

function getAdSectionFromOffer(offer: OfferUnion) {
	if (!('category' in offer) || !offer.category) {
		return '';
	}

	const currentCategory = categoriesMap.peek()[offer.category.id];
	return getCategorySectionFromCurrentCategory(currentCategory);
}

function getAdSectionFromFilters(filtersValue: FilterSignalData) {
	const { category, hledej } = filtersValue;

	if (category && category.id !== 0) {
		const currentCategory = categoriesMap.peek()[category.id];
		const section = getCategorySectionFromCurrentCategory(currentCategory);
		if (section) {
			return section;
		}
	}

	if (hledej.seoName) {
		return '';
	}

	return SSP_ADVERT_CONSTANTS.HP_SECTION;
}

export function getAdSection(offer?: OfferUnion, filtersValue?: FilterSignalData) {
	if (offer) {
		return getAdSectionFromOffer(offer);
	}

	if (filtersValue) {
		return getAdSectionFromFilters(filtersValue);
	}

	return '';
}
